export default "__VITE_ASSET__CmN4akVa__"